
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link, useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  const scrollToProjects = () => {
    const projectsSection = document.getElementById('projects-section');
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLearnMore = () => {
    navigate('/about');
    window.scrollTo(0, 0);
  };

  const handleGetInTouch = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  // Disable right-click and keyboard shortcuts
  const disableRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
    return false;
  };

  const disableKeyboardShortcuts = (e: React.KeyboardEvent) => {
    // Disable F12, Ctrl+Shift+I, Ctrl+U, Ctrl+S, Ctrl+Shift+C
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'C')) ||
      (e.ctrlKey && (e.key === 'u' || e.key === 'U' || e.key === 's' || e.key === 'S'))
    ) {
      e.preventDefault();
      return false;
    }
  };

  return (
    <div 
      className="min-h-screen bg-white select-none" 
      style={{ fontFamily: 'Helvetica, Arial, sans-serif', userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}
      onContextMenu={disableRightClick}
      onKeyDown={disableKeyboardShortcuts}
      onDragStart={(e) => e.preventDefault()}
    >
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://public.readdy.ai/ai/img_res/1b990d413eecbe7622cce6b57dcb1629.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center text-white flex flex-col justify-center h-full relative z-10">
          <div className="transform translate-y-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4 leading-tight">
              FUTURE/FORWARD
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-8">
              Creativity. Integrity. Performance.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="text-base sm:text-lg" onClick={scrollToProjects}>
                View Our Projects
              </Button>
              <Button variant="outline" size="lg" className="text-base sm:text-lg bg-white/10 border-white text-white hover:bg-white hover:text-gray-800" onClick={handleLearnMore}>
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6">
                Excellence in Development
              </h2>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                For over four decades, Canal Realty has been at the forefront of transforming urban landscapes. Our commitment to quality, innovation, and creativity drives every project we undertake.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                From thoughtfully designed commercial properties to luxury residential communities and state-of-the-art self-storage and industrial facilities, we deliver projects that create lasting value for their communities.
              </p>
              <Link to="/contact">
                <Button size="lg" onClick={handleGetInTouch}>Get In Touch</Button>
              </Link>
            </div>
            <div className="relative order-first lg:order-last">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20real%20estate%20development%20team%20reviewing%20architectural%20blueprints%20and%20building%20plans%20in%20modern%20office%20setting%2C%20business%20meeting%20with%20construction%20documents%2C%20urban%20planning%20and%20development%20consultation&width=600&height=400&seq=about-img&orientation=landscape"
                  alt="Development Team"
                  className="w-full h-64 sm:h-80 lg:h-96 object-cover object-top pointer-events-none select-none"
                  draggable="false"
                  onContextMenu={disableRightClick}
                  onDragStart={(e) => e.preventDefault()}
                />
                <div className="absolute inset-0 pointer-events-none select-none"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Overview */}
      <section id="projects-section" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6">
              Our Expertise
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
              Specialized development across multiple typologies, each tailored to meet the unique demands of modern business and living.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {/* Commercial */}
            <div className="bg-white p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="mb-6 relative">
                <img 
                  src="https://images.canalrealty.us/Cards/card-metro-plaza.png"
                  alt="Commercial Development"
                  className="w-full h-40 sm:h-48 object-cover object-top pointer-events-none select-none"
                  draggable="false"
                  onContextMenu={disableRightClick}
                  onDragStart={(e) => e.preventDefault()}
                />
                <div className="absolute inset-0 pointer-events-none select-none"></div>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Commercial</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
                Retail centers, office, and mixed-use developments that drive economic growth and create vibrant business communities.
              </p>
              <Link to="/projects/commercial">
                <Button variant="outline" className="w-full" onClick={() => window.scrollTo(0, 0)}>View Commercial Projects</Button>
              </Link>
            </div>

            {/* Residential */}
            <div className="bg-white p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="mb-6 relative">
                <img 
                  src="https://images.canalrealty.us/Cards/card-summit-a.jpg"
                  alt="Residential Development"
                  className="w-full h-40 sm:h-48 object-cover object-top pointer-events-none select-none"
                  draggable="false"
                  onContextMenu={disableRightClick}
                  onDragStart={(e) => e.preventDefault()}
                />
                <div className="absolute inset-0 pointer-events-none select-none"></div>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Residential</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
                Luxury apartments that fit harmoniously in their environments, designed for modern living with exceptional amenities and quality.
              </p>
              <Link to="/projects/residential">
                <Button variant="outline" className="w-full" onClick={() => window.scrollTo(0, 0)}>View Residential Projects</Button>
              </Link>
            </div>

            {/* Industrial */}
            <div className="bg-white p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="mb-6 relative">
                <img 
                  src="https://images.canalrealty.us/Cards/card-warehouse-interior.jpg"
                  alt="Industrial Development"
                  className="w-full h-40 sm:h-48 object-cover object-top pointer-events-none select-none"
                  draggable="false"
                  onContextMenu={disableRightClick}
                  onDragStart={(e) => e.preventDefault()}
                />
                <div className="absolute inset-0 pointer-events-none select-none"></div>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Industrial</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
                Warehouses and self-storage facilities built to support modern industry with efficiency and sustainability.
              </p>
              <Link to="/projects/industrial">
                <Button variant="outline" className="w-full" onClick={() => window.scrollTo(0, 0)}>View Industrial Projects</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-[#9B1F3A] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center">
            <div>
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2">75+</div>
              <div className="text-sm sm:text-base lg:text-lg">Projects Completed</div>
            </div>
            <div>
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2">40+</div>
              <div className="text-sm sm:text-base lg:text-lg">Years Experience</div>
            </div>
            <div>
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2">2M+</div>
              <div className="text-sm sm:text-base lg:text-lg">Square Feet</div>
            </div>
            <div>
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2">175+</div>
              <div className="text-sm sm:text-base lg:text-lg">Acres Land Development</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
